import { atom } from 'jotai';

export const executionPillClickAtom = atom<string | null>(null);
